import api from './index';
const config = {ignoreModal: true};
export default {
    context: () => api.get('/api/charts/context', config).then(res => res.data),
    options: input => api.post('/api/charts/options', input, config).then(res => res.data),
    query: input => api.post('/api/charts/query', input, config).then(res => res.data),
    settings: () => api.get('/api/charts/access-settings', config).then(res => res.data),
    objectAccess: () => api.get('/api/charts/object-access', config).then(res => res.data),
    saveSettings: input => api.put('/api/charts/access-settings', input, config).then(res => res.data)
};
